export enum SystemResourceCategory {
  GHG = 'GHG',
  FAQ = 'FAQ',
}

export enum SystemResourceType {
  DOCUMENT = 'DOCUMENT',
}
